module.exports = __webpack_public_path__ + "media/images/icons/flags/FM-1fdf107e10624a351ed13a7bb02a2bc5.svg";